import React from 'react'
import * as _ from 'lodash-es'
import { gql } from '@apollo/client'
import { PtSiteCtx } from './CustomSiteF/CustomSiteWrapperF'
import { isIgnorableJsErrMsg } from '../../pt0/sharedF/throwErrorF/constantsF.mts'
import { getExpBackoffLimited } from '../../pt0/sharedF/getExpBackoffLimitedF.mts'
import { apollo1Client } from './gqlF/apolloClientF.mts'

const ReportJsErrMut = gql`mutation ($gpJsErrJson: JsErrInputGqt!) {
  gmReportJsErr(gpJsErrJson: $gpJsErrJson)
}`

// per-key exp backoff (same SSOT fn as server maybeNotifErrF, but session-scoped + 1h cap/recovery
// since a tab is not a server process) plus a global rolling-minute cap against distinct-error storms
const jsErrRlHistH = /** @type {Record<string, any>} */ ({})
const mutTsA = []
const maxMutPerMin = 6

export const reportJsErr = (gpJsErrJson) => {
  if (isIgnorableJsErrMsg(gpJsErrJson.gpErrMsg)) return
  const {isLimited} = getExpBackoffLimited({
    cache_key: gpJsErrJson.gpErrMsg + gpJsErrJson.gpUrl, rlHistH: jsErrRlHistH,
    backoffCapMs: 3_600_000, recoveryPeriodMs: 3_600_000,
  })
  if (isLimited) return
  const now = Date.now()
  while (mutTsA.length && now - mutTsA[0] > 60_000) mutTsA.shift()
  if (mutTsA.length >= maxMutPerMin) return console.warn('reportJsErr: global rate cap hit, dropping', gpJsErrJson.gpErrMsg)
  mutTsA.push(now)
  try {
    apollo1Client.mutate({mutation: ReportJsErrMut, variables: {gpJsErrJson}}).catch(() => {})
  } catch {}
}

const reportWindowError = (gpErrMsg, gpErrStackS, gpUrl) => {
  reportJsErr({gpErrMsg: gpErrMsg?.slice(0, 2000), gpErrStackS: gpErrStackS?.slice(0, 5000), gpUrl})
}

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    try {
      reportWindowError(event.message, `${event.filename}:${event.lineno}:${event.colno}\n${event.error?.stack ?? ''}`, window.location?.href ?? '')
    } catch {}
  })
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const err = event.reason
      if (err?.graphQLErrors?.length) return
      reportWindowError(err?.message ?? String(err), err?.stack ?? '', window.location?.href ?? '')
    } catch {}
  })
}

/**
 * @typedef {object} JsErrDownProps
 * @property {string | undefined} [gpErrMsg]
 * @property {string | undefined} [gpErrStackS]
 * @property {string | undefined} [gpErrCompStackS]
 * @property {string} gpUrl
 */

export class ReportJsErrorWrap extends React.Component {
  /**
   * @param {any} props
   */
  constructor(props) {
    super(props)
    /** @type {{downProps: JsErrDownProps | null}} */
    this.state = {downProps: null}
  }
  componentDidCatch(error, errorInfo) {
    const gpUrl = typeof window !== 'undefined' ? (window.location?.href ?? '') : ''
    const {gpErrMsg, gpErrStackS} = _.isString(error)
      ? {gpErrMsg: error, gpErrStackS: ''}
      : {gpErrMsg: error?.message?.trim(), gpErrStackS: error?.stack?.trim()}
    const downProps = {gpErrMsg, gpErrStackS, gpErrCompStackS: errorInfo?.componentStack?.trim(), gpUrl}
    reportJsErr(downProps)
    this.setState({downProps})
  }
  render() {
    const {downProps} = this.state
    if (!downProps) return this.props.children
    const JsErrComp = this.props.JsErrComp || (({children}) => children)
    return <JsErrComp {...downProps}>
      <PtSiteCtx.Consumer>{(ctx) => ctx?.genericErrMsg ?? null}</PtSiteCtx.Consumer>
    </JsErrComp>
  }
}
